import { useAccountDataQuery } from '../queries/account';

export interface ProjectDetailFeatureFlags {
  isMeetingPagesEnabled: boolean;
  isEmailPagesEnabled: boolean;
  isDocumentationAgentEnabled: boolean;
  isScarletEnabled: boolean;
  isSignalsEnabled: boolean;
  isSignalsAnalystEnabled: boolean;
  isTimesheetPoliciesEnabled: boolean;
  isProjectGovernancePoliciesEnabled: boolean;
}

/**
 * Returns the feature flags used for project-detail and customer-portfolio tabs
 * (meetingPages, emailPages, documentationAgent, scarlet). Centralizes flag
 * extraction so flag names or defaults can change in one place.
 */
export const useAiFeatureFlags = (): ProjectDetailFeatureFlags => {
  const { data } = useAccountDataQuery();
  const features = data?.accountMeta?.features;

  return {
    isMeetingPagesEnabled: features?.meetingPages ?? false,
    isEmailPagesEnabled: features?.emailPages ?? false,
    isDocumentationAgentEnabled: features?.documentationAgent ?? false,
    isScarletEnabled: features?.scarlet ?? false,
    isSignalsEnabled: features?.signals ?? false,
    isSignalsAnalystEnabled: features?.signalsAnalyst ?? false,
    isTimesheetPoliciesEnabled: features?.timesheetPolicies ?? false,
    isProjectGovernancePoliciesEnabled: features?.policyEvaluation ?? false,
  };
};
